export class EnrollDocuments {
  id_type: number = null;
  id_number: string = '';
  doc_series: string = '';
  id_begin_date: Date;
  select_id_give_organ: number = null;
  id_give_organ: number = null;
  id_scan: any = {fileId: null};
  scan_086: any = {fileId: null};
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-documents.ts